"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuccessIcon = exports.EditIcon = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
exports.EditIcon = (0, styled_components_1.default)(react_fontawesome_1.FontAwesomeIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 2px 8px;\n"], ["\n  margin: 2px 8px;\n"])));
var fade = (0, styled_components_1.keyframes)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  20%, 80% { opacity: 1 }\n"], ["\n  20%, 80% { opacity: 1 }\n"])));
exports.SuccessIcon = (0, styled_components_1.default)(react_fontawesome_1.FontAwesomeIcon)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 2px 0;\n  opacity: 0;\n  animation: 4s ", " linear;\n  color: ", ";\n"], ["\n  margin: 2px 0;\n  opacity: 0;\n  animation: 4s ", " linear;\n  color: ", ";\n"])), fade, function (_a) {
    var theme = _a.theme;
    return theme.palette.successGreen;
});
var templateObject_1, templateObject_2, templateObject_3;
